import React from "react"
import { Field, reduxForm, Form } from "redux-form"
import { compose } from "recompose"
import { connect } from "react-redux"
import { Icon, Button } from "antd"
import { FormattedMessage } from "react-intl"
import Text from "../text"
import Box from "../../lib/ui/ui-box"
import Validators from "../../lib/validators"
import renderTextfield from "../render-textfield"
import { defaultValues } from "./options"
import * as Normalizers from "../../lib/normalizers"

const Step = props => {
  return (
    <Form onSubmit={props.handleSubmit}>
      <Box flexDirection="column">
        <Box w={["90%", "90%", "552px"]} flexDirection="column">
          {/* Category */}
          <Text
            fontFamily="Libre Baskerville"
            fontSize={[1, 1]}
            lineHeight={[3, 4]}
            fontWeight="300"
            color="#A8A7A9"
          >
            <FormattedMessage id="renewal.step_4.category" />
          </Text>
          {/* Title */}
          <Text
            fontFamily="Libre Baskerville"
            fontSize={[3, 4]}
            lineHeight={[3, 4]}
            fontWeight="700"
            color="#2B3E51"
          >
            <FormattedMessage id="renewal.step_4.title" />
          </Text>
        </Box>
        {/* Input Row */}
        <Box maxWidth="400px" mt={[2]}>
          {/* Input */}
          <Field
            name="telephoneNumber"
            component={renderTextfield}
            placeholder={props.intl.formatMessage({
              id: "renewal.step_4.placeholder_telephonenumber"
            })}
            normalize={Normalizers.normalizePhone}
            validate={[Validators.isRequired]}
            autoFocus
          />
        </Box>
        {/* Input Row */}
        <Box maxWidth="400px" mt={[2]}>
          {/* Input */}
          <Field
            name="emailAddress"
            component={renderTextfield}
            placeholder={props.intl.formatMessage({
              id: "renewal.step_4.placeholder_emailaddress"
            })}
            validate={[Validators.isRequired, Validators.isEmail]}
            autoFocus
          />
        </Box>
        <Box mt={[3]}>
          <Button.Group size="large">
            <Button
              size="large"
              disabled={props.invalid}
              type="primary"
              htmlType="submit"
            >
              <FormattedMessage id="renewal.cta" />
              <Icon type="right" />
            </Button>
          </Button.Group>
        </Box>
      </Box>
    </Form>
  )
}

export default compose(
  connect(state => ({
    initialValues: defaultValues
  })),
  reduxForm({
    form: "renewalMortgageWizard",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(Step)



// WEBPACK FOOTER //
// ./src/components/renewal-wizard/step-four.component.js